module.exports = __webpack_public_path__ + "img/kiem-tra-nang-luc-headline.61f5b6a9.png";